module.exports = __webpack_public_path__ + "img/file_csv.9c2d64b2.svg";